// extracted by mini-css-extract-plugin
export var arrows = "_73-6";
export var decrementer = "_73-a";
export var disabled = "_73-4";
export var error = "_73-1";
export var hiddenText = "_73-b";
export var incrementer = "_73-9";
export var input = "_73-8";
export var inputWrapper = "_73-0";
export var leadingIcon = "_73-c";
export var readonly = "_73-3";
export var regular = "_73-7";
export var small = "_73-5";
export var warning = "_73-2";